<template>
  <div id="app">
    <Header/>
    <transition name="fade" mode="out-in">
      <div class="main">
        <router-view :key="$route.params.id"/>
      </div>
    </transition>
    <Footer/>
    <!-- <app-loading v-show="loading"/> -->
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components:{
    Header,
    Footer
  },
}
</script>

<style>
/*页面切换动画*/
/*进入过渡的结束状态，元素被插入时就生效，在过渡过程完成后移除*/
.fade-enter-active {
    transition: opacity .1s;
}
/*进入过渡的开始状态，元素被插入时生效，只应用一帧后立刻删除*/
.fade-enter {
    opacity: 0;
}
/*离开过渡的开始状态，元素被删除时触发，只应用一帧后立刻删除*/
.fade-leave {
    opacity: 1;
}
/*离开过渡的结束状态，元素被删除时生效，离开过渡完成后被删除*/
.fade-leave-active {
    opacity:0;
    transition: opacity .1s;
}

::-webkit-scrollbar { width: 6px; height: 6px; background-color: #F8F8F8;}
::-webkit-scrollbar-track {border-radius: 6px; background-color: #F8F8F8;}
::-webkit-scrollbar-thumb {border-radius: 6px; background-color: #C8C6C4;}

.time01{transition: all .1s ease-out 0s;}
.time02{transition: all .2s ease-out 0s;}
.time03{transition: all .3s ease-out 0s;}
.time05{transition: all .5s;}

body{ font-size: 14px; color: #000; word-wrap: break-word; }
a{ text-decoration: none; color: #000; transition: all .1s;}
ul,li{ margin: 0; padding: 0;}
li{ list-style: none;}
p{ margin-bottom: 0;}
h1,h2,h3,h4,h5,h6,.letterA{letter-spacing: 3px;}

.bgA{ background-color: #f5f5f5;}

.menu li{ padding: 0 10px;}
.menu a{ display: block; font-weight: bold; font-size: .875rem; color: #211F20; letter-spacing: 1px;}
.menu a.cur{ color: #CBB778;}

.indexAbout .text img{ width: 50%; max-width: 300px; margin-left: auto; margin-right: auto;}

.projectDetail .bot p{ letter-spacing: .075rem; font-size: 0.9375rem; line-height: 2; margin-top: 1rem;}
.projectDetail .bot p:first-child{ margin-top: 0;}

.main{ padding-top: 60px;}

@media (min-width: 576px) {

}

@media (min-width: 768px) {

}

@media (min-width: 992px) {
  .main{ padding-top: 80px;}
  a:hover{ color: #CBB778;}
  .menu a:hover{ color: #CBB778;}

  .projectDetail .bot p{ margin-top: 1.5rem;}
}

@media (min-width: 1200px) {
    .indexAbout .text img{ position: absolute; right: 0; top: 0; width: 20%;}
}

@media (min-width: 1400px) {
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue